import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  .image {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: ${props => props.theme.palette.general.greyLight} no-repeat 50% 50% / cover;
    min-width: 260px;
    height: 150px;
  }

  .content {
    padding: 0 15px;
    box-sizing: border-box;
    color: ${props => props.theme.palette.general.strong};
    transition: box-shadow 300ms ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${bp('sm')`
      padding: 0 5px;
    `}
  }

  .title {
    font: ${font('alt', 'normal', '20px/1')};
    margin-bottom: 10px;
  }

  .subtitle {
    font: ${font('default', 'light', '16px/1.2')};
    overflow: hidden;
    text-overflow: ellipsis;
    /* stylelint-disable */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .action {
    ${props => props.theme.css.link}
    ${bp('sm')`
      font-weight: ${(props: any) => props.theme.font.default.bold};
      text-decoration: none;
      margin: 10px 0;
    `}
  }

  a {
    display: flex;
    user-select: none;
    text-decoration: none;
  }
`
